import cn from "classnames";
import { cloneElement } from "react";
import { A11yHighlightProps } from "./types";
import styles from "./styles.module.scss";

export const A11yHighlight = ({
  hasA11yFocus,
  children,
  className,
}: A11yHighlightProps) => {
  const { props } = children;

  return cloneElement(children, {
    ...props,
    className: cn(props.className, { [styles.focus]: hasA11yFocus }, className),
  });
};
